export default {
  fr: {
    Title: "MRMR",
    Tutorial: "Tutoriel",
    Period: {
      Title : 'Périodes de déclarations',
      PeriodDate : 'Date',
      Name : 'Nom',
      UpdateType: 'Type de mise à jour',
      IsActive : 'Actif',
      IsYearEnd : "YE",
      IsInternal : "Interne",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cette période {name}?",
      PeriodDeleted: "La période a été correctement supprimée",
      SelectAll : "Tout sélectionner",
      Step1 : "Base",
      Step2 : "Projets",
      SubmittedGeoStatementsCount : "Soumis Geo",
      SubmittedEngStatementsCount : "Soumis Ing.",
      ApprovedCorpoStatementsCount : "Approuvés Corpo.",
      UnplannedStatementsCount : "Non planifiés",
      OpenPeriodStatementsTooltip: "Accéder aux déclarations MRMR de cette période",
      LastStartingPointDate: "Dernier officiel",
      Project: "Projet",
      IsStartingPoint: "Nouvelle déclaration"
    },
    Statement: {
      Title : 'Déclaration des MRMR',
      Period : 'Periode',
      Project : 'Dépôt Mineral',
      Report : 'Rapport',
      PaginatedReport : 'Rapport paginé',
      RawData : 'Exporter les données brutes',
      Reason : 'Veuillez fournir la raison du rejet',
      QPEngineering : "PQ Ingénierie",
      QPGeology : "PQ Géologie",
      Ownership : "Appartenance AEM",
      CoreLoggingDatabaseClosureDate : "Fermeture BD Fusion",
      MetallurgicalRecovery: "Recupération métallurgique (%)",
      Device : "Devise",
      FXRate : "Taux de change",
      Notes : "Notes",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cette déclaration?",
      ConfirmDeleteMultiple : "Souhaitez-vous réellement supprimer ces déclarations?",
      ConfirmSubmission : "Souhaitez-vous soumettre cette déclaration au corporatif?",
      ConfirmCancelSubmission : "Souhaitez-vous annuler la soumission de cette déclaration?",
      NoComment : "Sans commentaire",
      ConfirmNoComments : "Souhaitez-vous soumettre cette déclaration sans aucun commentaire?",
      Reject : "Rejeter une déclaration",
      RejectShort : "Rejeter",
      ApprovalShort : "Approuver",
      ConfirmReject : "Souhaitez-vous rejeter cette déclaration?",
      ConfirmApproval : "Souhaitez-vous publier cette déclaration?",
      ConfirmApprovalByEngineering : "Souhaitez-vous approuver cette déclaration et la soumettre au corporatif?",
      StatementDeleted: "La déclaration a été correctement supprimée",
      MultipleStatementsDeleted : "Les déclarations ont été correctement supprimées",
      Duplicate : "Dupliquer la déclaration",
      Renew : "Reconduire la déclaration",
      SelectTargetPeriod : "Veillez sélectionner la période de déclaration ciblée",
      DuplicateSuccess : "La déclaration a été correctement dupliquée",
      RenewSuccess : "La déclaration a été correctement reconduite",
      NoStatementSelected : "Aucune déclaration sélectionnée",
      ComparaisonStats : "Statistiques de comparaison",
      AuOz : "Or (Oz)",
      AgOz : "Argent (Oz)",
      ZnOz : "Zinc (Oz)",
      PbOz : "Plomb (Oz)",
      CuOz : "Cuivre (Oz)",
      AuOzShort : "Au (Oz)",
      AuGradeShort : "Au (g/t)",
      New : "Création d'une nouvelle déclaration",
      Edit : "Edition d'une déclaration",
      View : "Consulter une déclaration",
      Tab1 : "Informations générales",
      Tab2 : "Entrées de déclarations",
      Tab3 : "Analyse comparative",
      UploadTemplateTonnageFile : 'Obtenir le modèle avec tonnage',
      UploadTemplateVolumeFile : 'Obtenir le modèle avec volume et densité',
      UploadFile : "Téléverser le fichier de déclaration",
      UploadWarning : "Le téléversement d'un fichier de déclaration écrasera toute entrée existante",
      UploadInvalidFileError : "Fichier de téléversement invalide",
      StatementMustBeCreated : "La déclaration doit être sauvegardé avant de téléverser le fichier d'entrées",
      UploadSuccess : "Le fichier d'entrées a été correctement importé",
      UploadFails : "Erreur d'importation",
      UploadFailText : "Le fichier possède un format inattendu.  Veuillez télécharger le modèle correspondant et réessayer",
      SubmitSuccess : "La déclaration a été correctement soumise",
      CancelSubmissionSuccess : "La soumission de la déclaration a été annulée",
      RejectSuccess : "La déclaration a été correctement rejetée",
      ApprovalSuccess : "La déclaration a été correctement publiée",
      ApprovalByEngineeringSuccess : "La déclaration a été correctement approuvée et soumise au corporatif",
      NoPreviousComparaison : "Aucune déclaration précédante disponible pour comparaison",
      Submission : "Soumission",
      Approbation : "Approbation",
      EngineeringApproval : "Approbation par l'ingénierie",
      SubmittedBy : "Soumis par",
      SubmissionDate : "Date de soumission",
      ApprovalDate : "Date d'approbation",
      ApprovedBy : "Approuvé par",
      SubmissionNotes : "Historique de soumission",
      CompareWithTitle: "Comparer avec",
      PromoteVersionTitle: "Promouvoir une version",
      PromoteVersionTooltip: "Promouvoir une version antérieure permet de rendre cette version active.  Les autres versions demeurent présentes dans l'historique.",
      ViewVersionTooltip: "Permet de visualiser une version spécifique",
      ViewVersionsTooltip: "Permet de visualiser la liste des versions",
      ConfirmPromoteVersion: "Souhaitez-vous promouvoir cette version de déclaration en tant que version active?",
      PromoteVersionSuccess : "La version a été promue avec succès",
      Version: "Version",
      VersionsTitle: "Liste des versions",
      Submit: "Soumettre une déclaration",
      CancelSubmission: "Annuler la soumission de la déclaration",
      ComparisonUnavailable: "La comparaison n'est pas disponible lorsque des modifications sont non sauvegardées.",
      ElementChart: "Élément (graphique)",
      SelectElementsChart: "Sélectionner les éléments à afficher dans les graphiques",
      Comparison : "Comparaison",
      BackToStatement :  "Retour à la déclaration",
      ViewDetailedReport : "Voir le rapport détaillé",
      NotesHelperLine1 : "1. Prix des matières premières spécifiques si exception par gisement/zone/zones (le cas échéant)",
      NotesHelperLine2 : "2. Y compris/excluant les réserves minérales (les lignes directrices de AEM excluent les réserves minérales)",
      NotesHelperLine3 : "3. MSO oui ou non, si oui quel logiciel",
      NotesHelperLine4 : "4. Conception d'une fosse à ciel ouvert pour les réserves minérales et forme d'optimisation de la fosse pour les ressources minérales",
      NotesHelperLine5 : "5. Grade de coupure ou grade NSR (utilisez 'pas moins que')",
      NotesHelperLine6 : "6. Hypothèses de dilution externe (plage ou moyenne), équivalent mètre ou %",
      NotesHelperLine7 : "7. Récupération minière (plage ou moyenne)",
      NotesHelperLine8 : "8. Largeur de modélisation minimale",
      NotesHelperLine9 : "9. Densité apparente (estimée ? Fixée par lithologie ?)",
      NotesHelperLine10 : "10. Méthode d'estimation",
      NotesHelperLine11 : "11. Hypothèse/raisonnement de récupération métallurgique",
      NotesHelperLine12 : "12. Quel logiciel pour l'estimation et quelle version",
      NotesHelperLine13 : "13. Toute autre spécification pertinente (permis, zones reclassées, etc.)"
    },
    Report : {
      Dashboard : "Tableau de bord",
      Consolidated :  "Déclarations MRMR consolidées",
      PerCommodity : "Consolidées par commodité"
    },
    ElementPrice : {
      Title : "Prix des métaux",
      Name : "Prix d'un métaux",
      Element : "Élement",
      Price : "Prix",
      ResourceCategory : "Catégorie",
      AddElement: "Ajouter un prix",
      EditElement: "Modifier le prix",
      DeleteElement: "Supprimer le prix"
    },
    Entry: {
      Title : 'Entrées de la déclaration',
      Area : 'Secteur',
      ResourceType : 'Catégorie MRMR',
      MiningType : "Méthode d'exploitation",
      Tonnage : 'Tonnage',
      Volume : 'Volume (m3)',
      Density : 'Densité (t/m3)', 
      ConfirmRestore : "Souhaitez-vous réellement restaurer cette entrée?",
      Restore : "restaurer",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cette entrée?",
      ConfirmDeleteMultiple : "Souhaitez-vous réellement supprimer ces entrées?",
      EntryDeleted: "L'entrée a été correctement supprimée",
      DuplicatedEntryException : "Il existe déjà une entrée pour ce secteur, méthode d'exploitation et catégorie",
      NoEntrySelected : "Aucune entrée sélectionnée",
      Grade : "Teneur",
      Grams : "g",
      Kilograms : "Kg",
      PreviousGrade : "Teneur précédente",
      PreviousTonnage : "Tonnage précédent",
      Step1 : "Information générales",
      Step2 : "Teneurs",
      Gold : 'Or (g/t)',
      Silver : 'Argent (g/t)',
      Copper : 'Cuivre (%)',
      Zinc : 'Zinc (%)',
      Lead : 'Plomb (%)',
      IsInclusive : 'Inclusive?',
      EntryMode : 'Mode de saisie',
      EntryModeGrade : 'Teneur',
      EntryModeQuantity : 'Quantité',
      Elements: "Éléments",
      AllElements: "Tous"
    },
    Devices : {
      '0' : "USD",
      '1' : "CAD",
      '2' : "EUR",
      '3' : "MXN",
      '4' : "AUD"
    },
    ResourceType : {
      '0' : "Potentiel minéral",
      '1' : "Présumées",
      '2' : "Indiquées",
      '3' : "Mesurées",
      '4' : "Probables",
      '5' : "Prouvées"
    },
    ResourceTypeFullName : {
      '0' : "Potentiel minéral",
      '1' : "Ressources présumées",
      '2' : "Ressources indiquées",
      '3' : "Ressources mesurées",
      '4' : "Réserves probables",
      '5' : "Réserves prouvées"
    },
    MiningType : {
      '0' : "Souterraine",
      '1' : "Ciel ouvert"
    },
    MetalPrices: {
      '1' : "Réserves minérales",
      '2' : "Ressources minérales"
    },
    ResourceCategories : {
      '1' : "P&P",
      '2' : "M&I",
      '3' : "Présumées",
      '4' : "Potentiel minéral"
    },
    NSR : {
      Title : "NSR",
      Scenarios : {
        Title : "Scénario"
      },
      Analytics : {
        Title : "NSR Analytics"
      }
    },
    QAQC : {
      Title: "QA/QC"
    },
    DiagramType : {
      Summary: "Diagrammes sommaires",
      Detailed: "Diagrammes détaillés",
      DetailedOrSummaryLabel: "Détaillé ou sommaire?"
    },
    OwnershipCalculation: {
      Label: "Calcul de l'appartenance AEM?",
      OwnershipPercentage: "Application du pourcentage d'appartenance AEM (%)",
    },
    UpdateType : {
      '0' : "Mise à jour",
      '1' : "Mise à jour et radiation",
      '2' : "Reconduire"
    },
    Qp : {
      Title: "QPs",
      Name: "Nom",
      Email: "Email",
      Occupation: "Occupation",
      HireDate: "Date d'embauche",
      AddNew: "Ajouter un QP",
      Edit: "Modifier un QP",
      ConfirmDelete: "Souhaitez-vous réellement supprimer ce QP?",
      QpDeleted: "Le QP sélectionné a été correctement supprimé",
      NoQpSelected: "Aucun QP sélectionné",
      Step1: "Informations générales",
      Step2: "Ordres professionnels",
      Step3: "Projets",
      ProfessionalOrderRegistrations: "Inscriptions aux ordres professionnels",
      ProfessionalOrderName: "Nom de l'ordre professionnel",
      RegistrationNumber: "Numéro d'inscription",
      AllowedProjects: "Projets autorisés",
      SelectAll: "Tout sélectionner",
      DeselectAll: "Tout désélectionner",
      WorkExperience: "Expérience professionnelle",
      Years: "ans",
      Year: "an",
      Months: "mois",
      Month: "mois",
      Days: "jours",
      Day: "jour",
      Comments: "Commentaires"
    },
    QPOccupation : {
      '0' : "Géologue",
      '1' : "Ingénieur"
    },
    ProfessionalOrder: {
      Title: "Ordres professionnels",
      Name: "Nom",
      AddNew: "Ajouter un ordre professionnel",
      Edit: "Modifier un ordre professionnel",
      ConfirmDelete: "Souhaitez-vous réellement supprimer cet ordre professionnel?",
      ProfessionalOrderDeleted: "L'ordre professionnel sélectionné a été correctement supprimé"
    },
    Variances: {
      Title: "Rapports de variance",
      Period: "Période",
      SubmittedBy: "Soumis par",
      SubmissionDate: "Date de soumission",
      Upload: {
        Title: "Rapport de variance",
        UploadFile: "Téléverser le fichier de rapport de variance",
        BrowseFile: "Parcourir le fichier",
        UploadSuccess: "Le rapport de variance a été correctement interpreté",
        UploadSuccessText: "Veuillez valider et confirmer que les informations ci-dessous correspondent bien au fichier soumis.",
        ValidationRule: "Règle de validation",
        ReturnToList: "Retour à la liste",
        ImportedSuccessfully: "Importé avec succès",
        SubmitNewFile: "Soumettre un nouveau fichier",
        ValidationsFailed: "Échec des validations",
        ValidationFailedText: "Le fichier soumis ne respecte pas les règles de validation suivantes :",
        BadFileExtension: "Veuillez choisir un fichier Excel",
        MRMRVarianceCategoryEnum: {
          0: "Épuisement des réserves minérales",
          1: "Épuisement des ressources minérales",
          2: "Variation nette du solde des stocks",
          3: "Interprétation/Forage",
          4: "Approche de minage",
          5: "Nouveaux paramètres d'estimation",
          6: "Nouveau COG",
          7: "Révision de la classification (autre que le forage)",
          8: "Étude et acquisition"
        },
        ReservesAsEstimated: "Réserves au {x} selon les estimations",
        ResourceAsEstimated: "Resources au {x} selon les estimations"
      },
      VarianceEntries: {
        Name: "Nom",
        VarianceGroup: "Groupe",
        Tonnage: "Tonnes",
        Grade: "Grade",
        Ounce: "Once",
        Category: "Catégorie",
        ProvenProbable: "Réserves prouvées et probables",
        MeasuredIndicated: "Ressources mesurées et indiquées",
        Inferred: "Ressources présumées"
      }
    }
  }
}